import { create } from "zustand";

interface UIState {
  isSearchActive: boolean;
  searchQuery: string;
}

interface UIActions {
  setSearchActive: (active: boolean) => void;
  setSearchQuery: (query: string) => void;
  toggleSearch: () => void;
}

export const useUIStore = create<UIState & UIActions>((set) => ({
  isSearchActive: false,
  searchQuery: "",
  setSearchActive: (active) => set({ isSearchActive: active }),
  setSearchQuery: (query) => set({ searchQuery: query }),
  toggleSearch: () => set((state) => ({ isSearchActive: !state.isSearchActive })),
}));
